import React from "react";

import { ArrowRightOutlined } from "@ant-design/icons";
import { Button, message, Radio, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoles,
  reportsApproval,
  updateReportsApproval,
  UpdateReportsApproval,
} from "../../../actions/companySettings";
import { headerTitles } from "../../../actions/masterdata/masterdata";
import { apis } from "../../../config/APIs";
import usePayAxios from "../../../config/useAxios";
import "./../styles/setting.css";
import AdvancedApproval from "./AdvancedApproval";
import HirarchicalApproval from "./HirarchicalApproval";

const { TabPane } = Tabs;

message.config({
  maxCount: 3,
});

const ApprovalReports = ({ hasWriteAccess }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [reportsApprovalData, setReportsApprovalData] = React.useState([]);
  const [rolesData, setRolesData] = React.useState([]);
  const [selectedRoles, setSelectedRoles] = React.useState([]);
  const reportsApprovalResponse = useSelector(
    (state) => state.companySetting.reportsApproval || {}
  );
  const updateReportsApprovalResponse = useSelector(
    (state) => state.companySetting.updateReportsApproval || {}
  );
  const rolesResponse = useSelector(
    (state) => state.companySetting.getRoles || {}
  );
  const [editMode, setEditMode] = React.useState(false);
  const { onCall: updateOptions } = usePayAxios({
    api: apis.hierarchyUpdateOptions,
    method: "post",
  });
  const { data, onCall } = usePayAxios({
    api: apis.hierarchyOptions,
    method: "get",
  });
  const { data: { data: report_approvals = [], status = false } = {} } =
    reportsApprovalResponse;
  const setTab = () => {};
  const [showApproval, setShowApproval] = React.useState(false);
  const [showAdvancedApproval, setShowAdvancedApproval] = React.useState(false);
  const [radioVal, setRadioVal] = React.useState("hierarchical");
  React.useEffect(() => {
    dispatch(reportsApproval({ module_type: "REPORT_APPROVAL" }));
    dispatch(getRoles({}));
    dispatch(
      headerTitles({
        title: "report_approvals",
        description: "",
      })
    );
    onCall({
      params: {
        seed_type: "reports_hierarchy",
        // module_type:"REPORT_APPROVAL"
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (status && report_approvals && Array.isArray(report_approvals)) {
      setReportsApprovalData(
        report_approvals?.map((ele, idx) => ({ ...ele, level: idx }))
      );
      setSelectedRoles(report_approvals?.map((k) => k.role_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsApprovalResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", error = "" } = {} } =
      updateReportsApprovalResponse;
    if (error === false) {
      dispatch(reportsApproval({ module_type: "REPORT_APPROVAL" }));
      message.success(<span className="messageText">{res_message}</span>);
      setEditMode(false);
      dispatch({
        type: UpdateReportsApproval.RESET,
      });
    } else if (error === true) {
      message.error(<span className="messageText">{res_message}</span>);
      dispatch({
        type: UpdateReportsApproval.RESET,
      });
    }
  }, [updateReportsApprovalResponse]);

  React.useEffect(() => {
    const { data: { data: roles = [], status = false } = {} } = rolesResponse;
    if (status) {
      setRolesData(roles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesResponse]);

  React.useEffect(() => {
    if (
      data?.data?.[0]?.seed_value === "with hierarchy" &&
      data?.data?.[0]?.seed_code?.includes("_1")
    ) {
      setRadioVal("hierarchical");
    } else if (
      data?.data?.[0]?.seed_value === "Custom Approval Flow" &&
      data?.data?.[0]?.seed_code?.includes("_2")
    ) {
      setRadioVal("advanced");
    }
  }, [data]);

  const handleSubmit = () => {
    const dataArray = reportsApprovalData.map(
      ({ company_id, description, ...rest }) => rest
    );
    dispatch(
      updateReportsApproval({
        data: [...dataArray],
        params: { module_type: "REPORT_APPROVAL" },
      })
    );
  };
  const handleCancel = () => {
    setReportsApprovalData(report_approvals);
    setEditMode(false);
  };

  const handleApproveList = (type, key) => {
    if (type === "add") {
      setReportsApprovalData([
        ...reportsApprovalData,
        {
          can_approve_or_reject: false,
          can_reimburse: false,
          // id: reportsApprovalData.length,
          level: reportsApprovalData.length,
          role_name: "",
          is_active: true,
        },
      ]);
    } else {
      let idx = -1;
      const filterArray = reportsApprovalData.map((obj, index) => {
        if (obj.level === key && obj?.id) {
          obj.is_active = false;
        } else if (obj.level === key) {
          idx = index;
        }
        return obj;
      });
      if (idx > -1) {
        filterArray.splice(idx, 1);
      }
      const updatedArray = filterArray.map(({ level, ...rest }, index) => {
        return { level: index, ...rest };
      });
      setReportsApprovalData([...updatedArray]);
    }
  };

  return (
    <>
      {showApproval ? (
        <Tabs
          onChange={setTab}
          type="card"
          size="large"
          className="custom-tabs"
        >
          <TabPane tab={t("hierarchy_approval")} key="preferences">
            <div className="tabContentWrapper">
              {showAdvancedApproval ? (
                <AdvancedApproval
                  inv_type={"REPORT_APPROVAL"}
                  type={"REPORT"}
                  approvalData={reportsApprovalData}
                  hasWriteAccess={hasWriteAccess}
                />
              ) : (
                <HirarchicalApproval
                  approvalData={reportsApprovalData}
                  setApprovalData={setReportsApprovalData}
                  editMode={editMode}
                  handleList={handleApproveList}
                  selectedRoles={selectedRoles}
                  setSelectedRoles={setSelectedRoles}
                  rolesData={rolesData}
                  hirarchicalApprovalCheckBoxTitle="reports"
                  hasWriteAccess={hasWriteAccess}
                />
              )}
              {editMode &&
                rolesData?.filter(
                  (ele) =>
                    ele.role_name !== "Admin" &&
                    !reportsApprovalData
                      ?.filter((ele) => ele.is_active !== false)
                      ?.map((ele) => ele.role_id)
                      ?.includes(ele?.id)
                )?.length > 0 && (
                  <Button
                    type="default"
                    disabled={!editMode || !hasWriteAccess}
                    ghost
                    className="approve-add-btn mt1"
                    onClick={() => handleApproveList("add")}
                  >
                    {t("add_one_more")}
                  </Button>
                )}
              <div className="floatBottom">
                <>
                  {!editMode && !showAdvancedApproval && (
                    <Button
                      disabled={!hasWriteAccess}
                      className="formButton mt1 primaryButton"
                      onClick={() => setEditMode(true)}
                    >
                      {t("edit")}
                    </Button>
                  )}
                  {!editMode && (
                    <Button
                      key="2"
                      className="cancelButton ml1 mt1"
                      onClick={() => {
                        setShowApproval(false);
                      }}
                    >
                      {t("back")}
                    </Button>
                  )}
                </>
                {editMode && (
                  <>
                    <Button
                      disabled={!hasWriteAccess}
                      key="1"
                      className="formButton mt1 primaryButton"
                      onClick={() => handleSubmit()}
                    >
                      {t("save")}
                    </Button>
                    <Button
                      key="2"
                      className="cancelButton ml1 mt1"
                      onClick={() => handleCancel()}
                    >
                      {t("cancel")}
                    </Button>
                  </>
                )}
              </div>
            </div>
          </TabPane>
        </Tabs>
      ) : (
        <div className="tabContentWrapper">
          <h3>{t("approval_types")}</h3>
          <Radio.Group
            className="w100"
            onChange={(e) => {
              setRadioVal(e.target.value);
            }}
            value={radioVal}
            disabled={!hasWriteAccess}
          >
            <div
              className={`hierarchical-select ${
                radioVal === "hierarchical" ? "active" : ""
              }`}
              onClick={() => {
                if (hasWriteAccess) {
                  setRadioVal("hierarchical");
                  updateOptions({
                    data: {
                      seed_type: "reports_hierarchy",
                      seed_code: "REP_1",
                      is_active: true,
                    },
                  });
                }
              }}
            >
              <Radio
                disabled={!hasWriteAccess}
                name="hierarchical"
                checked={radioVal === "hierarchical"}
                value={"hierarchical"}
              />
              <div>
                <span>{t("hierarchy_approval")}</span>
                <span>{t("approval_flow")}</span>
                {radioVal === "hierarchical" ? (
                  <ArrowRightOutlined
                    onClick={() => {
                      setShowApproval(true);
                    }}
                  />
                ) : null}
              </div>
            </div>
            <div
              className={`hierarchical-select ${
                radioVal === "advanced" ? "active" : ""
              }`}
              onClick={() => {
                if (hasWriteAccess) {
                  setRadioVal("advanced");
                  updateOptions({
                    data: {
                      seed_type: "reports_hierarchy",
                      seed_code: "REP_2",
                      is_active: true,
                    },
                  });
                }
              }}
            >
              <Radio
                disabled={!hasWriteAccess}
                name="advanced"
                checked={radioVal === "advanced"}
                value={"advanced"}
              />
              <div>
                <span>Advanced Approval</span>
                <span>
                  You can set up an approval flow based on one or more criteria.
                  These criteria can be chosen by you.
                </span>
                {radioVal === "advanced" ? (
                  <ArrowRightOutlined
                    onClick={() => {
                      setShowAdvancedApproval(true);
                      setShowApproval(true);
                    }}
                  />
                ) : null}
              </div>
            </div>
          </Radio.Group>
        </div>
      )}
    </>
  );
};

export default ApprovalReports;
